import React, { useContext, useEffect, useState } from 'react';
import {
  Button,
  Card, Col, Empty, Result, Row, Tooltip,
} from 'antd';
import Icon from '@mdi/react';
import { mdiChevronRight } from '@mdi/js';

import {
  UI54Colors, UI54Icon, UI54Table, UI54Tag,
} from '@ecosystem54/react54kit';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import AntTable from '../../components/AntTable';

import { ApiContext } from '../../api/ApiContextProvider';
import useURLParams from '../../hooks/useURLParams';
import BaseCard from '../../_ui/BaseCard/BaseCard';
import BaseIcon from '../../_ui/BaseIcon/BaseIcon';
import BaseButton from '../../_ui/BaseButton/BaseButton';
import PublicInterfacesModalPage from './PublicInterfacesModalPage';
import { COLORS } from '../../54origins/components/publicInterface54Origins/publicInterfaceIconsConstants54Origins';
import InterfaceIcon54Origins from '../../54origins/components/publicInterface54Origins/InterfaceIcon54Origins';
import { capitalize } from '../../mainUtils';

function PublicInterfacesListModal({
  publicInterfaces = [],
  isActorRootOrAdmin = false,
  isActorBanned = false,
}) {
  const { t } = useTranslation();

  const { routeNavigateAndClearParams } = useURLParams();

  useEffect(() => {

  }, []);

  return (
    <Row gutter={[24, 16]}>
      {publicInterfaces.map((item) => (
        <Col span={24}>
          <BaseCard>
            <Row>
              <Col span={12}>
                <Tooltip title={item?.service_name}>
                  <UI54Tag variant="solid" color={COLORS[item?.icon_color] || COLORS.GRAY} className="cursor-default max-width-200px">
                    <InterfaceIcon54Origins
                      iconName={item?.service_icon}
                      color="WHITE"
                      size={1}
                      className="mr-2"
                      style={{
                        flex: '1 0 auto',
                      }}
                    />
                    <p className="truncate">{item?.service_name}</p>
                  </UI54Tag>
                </Tooltip>
              </Col>
              <Col span={12} className="flex">
                <BaseButton
                  type="link"
                  className="ml-auto"
                  onClick={() => (routeNavigateAndClearParams('/admin/public-interfaces', {
                    interface_name: item.service_name,
                  }))}
                >
                  go to interface
                  <BaseIcon path={mdiChevronRight} size={1} />
                </BaseButton>
              </Col>
            </Row>
          </BaseCard>
        </Col>
      ))}
      {(!isActorBanned && publicInterfaces.length === 0) ? (
        <Col span={24}>
          <BaseCard>
            <Empty description="Interfaces not found" />
          </BaseCard>
        </Col>
      ) : null}
      {isActorBanned ? (
        <Col span={24}>
          <BaseCard>
            <Result
              title={capitalize(t('auth.headers.interfaces_is_ban'))}
              subTitle={capitalize(t('auth.notifications.interfaces_is_ban'))}
              status="warning"
            />
          </BaseCard>
        </Col>
      ) : null}
    </Row>
  );
}

export default PublicInterfacesListModal;

PublicInterfacesListModal.propTypes = {
  publicInterfaces: PropTypes.array,
  isActorRootOrAdmin: PropTypes.bool,
  isActorBanned: PropTypes.bool,
};
